import Swiper from "swiper/bundle";

const initializeStackedCards = (stackedCardsSlider) => {
  new Swiper(stackedCardsSlider, {
    effect: "cards",
    grabCursor: true,
    navigation: { 
      nextEl: '.stacked-cards__item-btn.next', 
      prevEl: '.stacked-cards__item-btn.prev', 
    },
    direction: 'vertical',
    breakpoints: {
      1024: {
        direction: 'horizontal',
      },
    },
  });
};

const StackedCards = () => {
  const stackedCardsSliders = [...document.querySelectorAll(".stacked-cards__list")];

  if (stackedCardsSliders.length > 0) {
    const observerOptions = {
      root: document,
      rootMargin: "100% 0px 100% 0px", 
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          initializeStackedCards(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    stackedCardsSliders.forEach(stackedCardsSlider => {
      observer.observe(stackedCardsSlider);
    });
  }
};

export default StackedCards;
